import React, { useEffect } from "react";
import { handleFacebookRedirectResult, handleFBsignInWithCredential } from "../firebase/firebase-handler";
import { useNavigate } from "react-router-dom";
import { CancelButton } from "../util/CancelButton";

export const AuthHandlerLogger = () => {
    const navigate = useNavigate();

    const onError = (error) => {
        console.log(`[AuthHandlerLogger] got the error: ${error}`);
    };

    const onSuccess = (error) => {
        console.log(`[AuthHandlerLogger] succesfully logged in via fb: ${error}`);
        navigate("/");
    };

    const CancelLogin = () => {
        navigate("/");
    };

    useEffect(() => {
        handleFacebookRedirectResult(
            (result) => {
                console.log("[FB AuthHandler] OAuth code received:", result.code);
                handleFBsignInWithCredential(result.code, onSuccess, onError);

                //navigate("/"); // go to main page
            },
            (error) => {
                console.error("[FB AuthHandler] OAuth error:", error);
                navigate("/"); // back to login page
            }
        );
    }, [navigate]);

    return (
        <div>
            <div className="center center-boarder">
                <div className="bottle-loader">
                    <div className="bubble"></div>
                    <div className="bubble"></div>
                    <div className="bubble"></div>
                </div>
                <br></br>
                <p>Processing Login...</p>
            </div>
            <CancelButton onClick={CancelLogin}></CancelButton>
        </div>
    );
};
